import React, { type PropsWithChildren, } from 'react';
import OauthAuthContextProvider from '../auth/OauthAuthContextProvider';
import ChatServiceProvider from '../chat/ChatServiceProvider';
import useAnalytics from '../../hooks/useAnalytics';
import AppInfoServiceProvider from '../app-info/AppInfoServiceProvider';
import BackendEventsServiceProvider from '../backend-events/BackendEventsServiceProvider';
import LayoutProvider from '../layout/LayoutContext';

const AppContextBootstrap: React.FC<PropsWithChildren> = ({ children }) => {
    return (
        // LayoutProvider has 'hasCookieConsent' prop that is being set in useAnalytics(); <-- Thus this is why this context is here.
        <LayoutProvider>
            <AppContextBootstrapChildren>
                {children}
            </AppContextBootstrapChildren>
        </LayoutProvider>
    );
};

const AppContextBootstrapChildren: React.FC<PropsWithChildren> = ({ children }) => {
    useAnalytics();

    return (
        <OauthAuthContextProvider>
            <BackendEventsServiceProvider>
                <AppInfoServiceProvider>
                    <ChatServiceProvider>
                        {children}
                    </ChatServiceProvider>
                </AppInfoServiceProvider>
            </BackendEventsServiceProvider>
        </OauthAuthContextProvider >
    );
};

export default AppContextBootstrap;